import { createApiPath, createFetchAndCall } from '../fetch/fetchServices';
import * as apiConstants from '../../constants/apiConstants';

class EstablishmentUser {

  static createEstablishmentUser(establishmentUserObj) {
    let createEstablishmentUserApiPath =
      createApiPath(apiConstants.establishmentUserApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(establishmentUserObj)
    };
    return createFetchAndCall(createEstablishmentUserApiPath, options);
  }

  static editEstablishmentUser(establishmentUserObj) {
    let editEstablishmentUserApiPath =
      createApiPath(apiConstants.establishmentUserApi);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'PATCH',
      headers: headers,
      body: JSON.stringify(establishmentUserObj)
    };
    return createFetchAndCall(editEstablishmentUserApiPath, options);
  }

  static saveEstablishmentUsers(establishmentUserObj) {
    let operTypeVal = establishmentUserObj.operationType.toLowerCase() === 'C'.toLowerCase() ? 'POST': 'PATCH';
    let establishmentUserApiPath =
      createApiPath(apiConstants.establishmentUserApi);
      let headers = {
        'accept': 'application/json',
        'content-type': 'application/json',
        'Cache-Control': 'no-cache'
      };
      let options = {
        method: operTypeVal,
        headers: headers,
        body: JSON.stringify(establishmentUserObj)
      };
      return createFetchAndCall(establishmentUserApiPath, options);
  }

  static getEstablishmentUsersApi(establishmentId) {
    let apiPath = createEstUserApiPath(apiConstants.getEstablishmentUsersApi, establishmentId);
    let getAllEstablishmentUsersApiPath = createApiPath(apiPath);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json'
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(getAllEstablishmentUsersApiPath, options);
  }

  static validateEstablishmentUser(userEmail) {
    let apiPath = createEstUserApiPath(apiConstants.validateEstablishmentUserApi, userEmail);
    let validateUserApiPath = createApiPath(apiPath);
    let headers = {
      'accept': 'application/json',
      'content-type': 'application/json',
      'Cache-Control': 'no-cache'
    };
    let options = {
      method: 'GET',
      headers: headers
    };
    return createFetchAndCall(validateUserApiPath, options);
  }
}

function createEstUserApiPath(link, establishmentId) {
  if (establishmentId) {
    link = `${link}/${establishmentId}`;
  }
  return link;
}

export default EstablishmentUser;


/** WEBPACK FOOTER **
 ** ./src/api/establishment/EstablishmentUserApi.js
 **/